import { Entry } from 'contensis-delivery-api';
import HTMLReactParser from 'html-react-parser';

import type { SearchResultCardProps } from 'Components/Card/SearchResult';

import cmsParser from 'Common/util/cmsParser';
import { getSlugFromContentType } from 'Common/util/ben';

const mediaHubMap = (item: Entry, tag: string, uriDomain: string): SearchResultCardProps => ({
    heading: item.pageMetadata?.customTitle || item.title,
    description:
        typeof item.description === 'string'
            ? HTMLReactParser(item.description)
            : item.pageMetadata?.description
            ? item.pageMetadata.description
            : undefined,
    tag: tag,
    link: {
        href: `${uriDomain}/media-hub/${getSlugFromContentType(
            item.sys.contentTypeId,
            item.isIndependentBlog || item.customTags
        )}/${item.sys.slug}`
    },
    image: item.heroImage
        ? cmsParser.image(item.heroImage, '/cms/ben')
        : item.videoThumbnail
        ? cmsParser.image(item.videoThumbnail, '/cms/ben')
        : undefined
});

export default mediaHubMap;
